window.widenUtils = function widenUtils() {};

widenUtils.getDimensionsFromAssetUrl = function(url) {
  // Returns object w/ width/height or null... should be at position 6 in array
  var a = url.split('/');
  if (a[6] !== undefined) {
    if (a[6].indexOf('px') != -1 && !isNaN(parseInt(a[6]))) {
      var b = a[6].split('x');
      return {
        width: parseInt(b[0]),
        height: parseInt(b[1])
      }
    }
  }
  return null;
}

widenUtils.getFixedWidthImage = function(id, name, width) {
  return 'https://embed.widencdn.net/img/springswindowfashions/' + id + '/' + width + 'px/' + name + '.jpg';
}

widenUtils.getCustomSizeImage = (id, name, width, height) => {
  return `https://embed.widencdn.net/img/springswindowfashions/${id}/${width}x${height}px/${name}.jpg`;
};

widenUtils.getImageNameFromAssetUrl = function(url) {
  var ind1 = url.lastIndexOf('/') + 1,
    ind2 = url.lastIndexOf('.');
  if (ind1 !== 0 && ind2 !== -1) {
    return url.substring(ind1, ind2);
  }
  return url;
}

widenUtils.getIdFromAssetUrl = function(url) {
  if (!url) {
    return url;
  }
  var urlPiece = url.match(/springswindowfashions\/(.*?)\//);
  if (urlPiece !== null) {
    return urlPiece[1]
  }
  return url;
}

